import { Component, OnInit, Input, Output, EventEmitter }                                               from "@angular/core";
import { AccountSummary, Pagination, Organisation, AccountStatus, AccountRole, GlobalRole, Diocese }    from "../../../models";
import { USERHOMECONSTANTS }                                                                            from "../userHome.constants";
import { CurrentUserService }                                                                           from "../../../services/shared";
import { AccountsService }                                                                              from "./accounts.service";
import { UserHomeService }                                                                              from "../userHome.service";
import { NgProgressService }                                                                            from "ng2-progressbar";
import * as swal                                                                                        from "sweetalert2";

@Component({
    selector: "accounts-component",
    template: require("./accounts.component.html"),
    styles: [require("./accounts.component.less").toString()],
    providers: [AccountsService]
})

export class AccountsComponent implements OnInit {
    @Input() accountList: AccountSummary[];
    @Output() refreshList: EventEmitter<any> = new EventEmitter();
    errorMessage: string;
    isProcessing: boolean;
    accountsComponent = {
        sortColumnIndex: 1,
        sortOrder: USERHOMECONSTANTS.sorting.ascOrderString,
        sortColumn: "Firstname",
        pagination: new Pagination(),
        accounts: new Array<AccountSummary>()
    };
    isDioceseUser: boolean;
    searchComponent = {
        keyword: "",
        organisationId: "",
        statusCode: "",
        roleCode: "",
        accountCode: "",
        dioceseId: ""
    };

    organisations: Organisation[];
    diocese: Diocese[];
    accountStatuses: AccountStatus[];
    roles: AccountRole[];
    globalRoles: GlobalRole[];
    userName: string;
    isRoleFilter: boolean;

    constructor(private pService: NgProgressService, private currentUserService: CurrentUserService,
        private accountsService: AccountsService, private userHomeService: UserHomeService) {
        this.accountsComponent.pagination = {
            totalItems: 0,
            currentPage: USERHOMECONSTANTS.pagination.currentPage,
            itemsPerPage: USERHOMECONSTANTS.pagination.itemsPerPage,
            maxSize: USERHOMECONSTANTS.pagination.maxSize
        };
        this.searchComponent = {
            keyword: "",
            organisationId: "00000000-0000-0000-0000-000000000001",
            statusCode: "-1",
            roleCode: "-1",
            dioceseId: "-1",
            accountCode: "-1"
        };
    }

    public ngOnInit() {
        this.pService.start();
        this.GetDioceses();
        this.GetAccountStatuses();
        this.GetRoles();
        this.GetGlobalRoles();
        this.isDioceseUser = this.currentUserService.IsDiocesanUser();
        this.isRoleFilter = ( this.currentUserService.IsGlobalAdmin() || this.currentUserService.IsDiocesanAdmin() || this.isDioceseUser);
        this.GetAccounts();
        this.pService.done();
    }

    public PageChanged(currentPageObject): void {
        this.pService.start();
        this.accountsComponent.pagination.currentPage = currentPageObject.page;
         this.GetAccounts();
        this.pService.done();
    }

    public SortIconClass(columnIndex): string {
        if (columnIndex === this.accountsComponent.sortColumnIndex) {
            if (this.accountsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                return USERHOMECONSTANTS.sorting.ascIconClass;
            } else {
                return USERHOMECONSTANTS.sorting.descIconClass;
            }
        } else {
            return "";
        }
    }

    public DeLink(accountOrganisationId: string, name: string, organisationName: string): void {
        this.pService.start();
        this.DelinkOrganisation(this.accountsService, accountOrganisationId, name, organisationName);
        this.GetAccounts();
        this.pService.done();
    }

    private DelinkOrganisation(accountsService: AccountsService, accountOrganisationId: string, name: string, organisationName: string): void {
        swal({
            title: "Delink " + name,
            text: "you are about to disassociate user from " + organisationName,
            type: "info",
            showCancelButton: true,
            confirmButtonText: "Ok"
        }).then(function () {
            accountsService.DelinkOrganisation(accountOrganisationId)
                .subscribe(
                response => {
                    swal({
                        title: "Delink " + name,
                        text: response,
                        type: "info",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    })
                });
            (error) => {
                let parsedError = JSON.parse(error._body);
                if (parsedError) {
                    this.errorMessage = parsedError.message;
                }
            };
        });
    }

    public onSubmit(): void {
        this.pService.start();
        this.GetAccounts();
        this.pService.done();
    }
    public Reset(): void {

        this.searchComponent = {
            keyword: "",
            organisationId: "00000000-0000-0000-0000-000000000001",
            statusCode: "-1",
            roleCode: "-1",
            dioceseId: "-1",
            accountCode: "-1"
        };

        this.pService.start();
        this.GetDioceses();
        this.GetAccountStatuses();
        this.GetRoles();
        this.GetGlobalRoles();
        this.isDioceseUser = this.currentUserService.IsDiocesanUser();
        this.isRoleFilter = ( this.currentUserService.IsGlobalAdmin() || this.currentUserService.IsDiocesanAdmin() || this.isDioceseUser);
        this.GetAccounts();
        this.pService.done();
    }

    public onHandleProcessing(isProcessing) {
        this.isProcessing = isProcessing;
    }

    public SetOrganisation(extOrganisationId: string): void {
        this.searchComponent.organisationId = extOrganisationId;
    }

    public SetOrganisationsByDiocese (dioceseId: string): void {
      
        if(dioceseId !== "-1"){
            this.accountsService
            .GetOrganisationsByDioceseId(dioceseId)
            .subscribe(
            (response: Organisation[]) => {
                this.organisations = response;
                var organisation = new Organisation();
                organisation.extOrganisationId = "00000000-0000-0000-0000-000000000001";
                organisation.publicId = "00000000-0000-0000-0000-000000000001";
                organisation.name = "ALL";
                this.organisations.splice(0,0, organisation);
                this.searchComponent.organisationId = organisation.extOrganisationId;
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
        } else {

            this.organisations = [];
            var organisation = new Organisation();
            organisation.extOrganisationId = "00000000-0000-0000-0000-000000000001";
            organisation.publicId = "00000000-0000-0000-0000-000000000001";
            organisation.name = "ALL";
            this.organisations.splice(0,0, organisation);
            this.searchComponent.organisationId = organisation.extOrganisationId;

            if(this.currentUserService.IsGlobalAdmin()) {
                var organisationDelink = new Organisation();
                organisationDelink.extOrganisationId = "0778F56A-70FB-4A32-94D9-151828E21287";
                organisationDelink.publicId = "0778F56A-70FB-4A32-94D9-151828E21287";
                organisationDelink.name = "Not associated with an Organisation";
                    this.organisations.splice(1,0, organisationDelink);
            } 

            this.searchComponent.organisationId = "00000000-0000-0000-0000-000000000001";
        }
    }

    public SortList(columnIndex: number) {
        if (columnIndex === this.accountsComponent.sortColumnIndex) {
            if (this.accountsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                this.accountsComponent.sortOrder = USERHOMECONSTANTS.sorting.descOrderString;
            } else {
                this.accountsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            }
        } else {
            this.accountsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            switch (columnIndex) {
                case 1:
                    this.accountsComponent.sortColumn = "Firstname";
                    break;
                case 2:
                    this.accountsComponent.sortColumn = "Lastname";
                    break;
                case 3:
                    this.accountsComponent.sortColumn = "DioceseName";
                    break;
                case 4:
                    this.accountsComponent.sortColumn = "GlobalRoleCode";
                    break;
                case 5:
                    this.accountsComponent.sortColumn = "OrganisationName";
                    break;
                case 6:
                    this.accountsComponent.sortColumn = "PositionCode";
                    break;
                case 7:
                    this.accountsComponent.sortColumn = "FromDate";
                    break;
                case 8:
                    this.accountsComponent.sortColumn = "ToDate";
                    break;
                case 9:
                    this.accountsComponent.sortColumn = "OrganisationStatusCode";
                    break;

                default:
                    this.accountsComponent.sortColumn = "Firstname";
            }
        }

        this.accountsComponent.sortColumnIndex = columnIndex;
        //let organisation = this.organisations.find(o => o.extOrganisationId === this.searchComponent.organisationId);
        this.pService.start();
        this.GetAccounts();
        this.pService.done();
    }

    public GetAccounts(): void {
        this.isProcessing = true;
        let odataUrl = this.BuildOdataUrl();
        this.accountsService
            .GetAccountsList( this.accountsComponent.pagination, this.accountsComponent.sortOrder, this.accountsComponent.sortColumn, odataUrl)
            .map(response => response.json())
            .subscribe(
            response => {
                // send the retrieved accounts to the parent page which has the <accounts-component> in it, through the refreshList event
                this.refreshList.emit(<AccountSummary[]>response.result);
                this.accountsComponent.pagination.totalItems = response.count; // get from the response 
                this.userHomeService.confirmTotalItemUpdate(response.count); // get from the response
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                    this.accountsComponent.accounts = [];
                }
            });

        this.isProcessing = false;
    }

    public GetAccountsListNames(accountSummaries: AccountSummary[]): void {
        this.accountsService
            .GetAccountsListNames(accountSummaries)
            .map(response => response.json())
            .subscribe(
            response => {
                this.refreshList.emit(<AccountSummary[]>response.result);
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    private GetAccountStatuses(): void {
        this.accountsService
            .GetAccountStatuses()
            .subscribe(
            (response: AccountStatus[]) => {
                this.accountStatuses = response;
                let allStatus = new AccountStatus();
                
                if(!this.currentUserService.IsGlobalAdmin() || this.currentUserService.IsDiocesanAdmin())
                {
                    this.accountStatuses = this.accountStatuses.filter(i=> i.code !== "InActive");
                }
                allStatus.code = "-1";
                allStatus.name = "ALL";
                allStatus.description = "All statues";
                this.accountStatuses.unshift(allStatus);
                this.searchComponent.statusCode = allStatus.code;
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    private BuildOdataUrl(): string {

        let odataUrl = "";
        let filterSet = false;
     
        if (this.searchComponent.statusCode !== "-1" || this.searchComponent.roleCode !== "-1" || this.searchComponent.accountCode !== "-1"
            || (this.searchComponent.organisationId && this.searchComponent.organisationId !== "00000000-0000-0000-0000-000000000001") || this.searchComponent.keyword !== "" 
        || this.searchComponent.dioceseId !== "-1") {
            odataUrl = "$filter=";
            if (this.searchComponent.keyword) {
                let keyWord = encodeURIComponent(this.searchComponent.keyword.replace(/'/g, "''").toLowerCase());
                odataUrl += "(contains(tolower(Firstname),'" + keyWord +"') or contains(tolower(Lastname),'" + keyWord +"') or contains(tolower(DisplayName),'" + keyWord + "'))";
                filterSet = true;
            }

            if (this.searchComponent.statusCode !== "-1") {
                if (filterSet) {
                    odataUrl += "and (AccountStatusCode eq '" + this.searchComponent.statusCode + "')";
                }
                else {
                    odataUrl += "(AccountStatusCode eq '" + this.searchComponent.statusCode + "')";
                    filterSet = true;
                }
            }

            if (this.searchComponent.roleCode !== "-1") {
                if (filterSet) {
                    odataUrl += "and (RoleCode eq '" + this.searchComponent.roleCode + "')";
                }
                else {
                    odataUrl += "(RoleCode eq '" + this.searchComponent.roleCode + "')";
                    filterSet = true;
                }
            }

            if (this.searchComponent.organisationId !== "00000000-0000-0000-0000-000000000001") {
                if (filterSet) {
                    odataUrl += "and (ExtOrganisationId eq " + this.searchComponent.organisationId + ")";
                }
                else {
                    odataUrl += "(ExtOrganisationId eq " + this.searchComponent.organisationId + ")";
                    filterSet = true;
                }
            }
            
            if (this.searchComponent.dioceseId !== "-1") {
                let dioceseName = this.diocese.find( i=> i.dioceseId.toString() === this.searchComponent.dioceseId).dioceseName;
                let subString = dioceseName.indexOf('&');
                if(subString> -1){
                    dioceseName = dioceseName.substring(0,subString);
                  
                }

                if (filterSet) {
                    odataUrl += "and (indexof(DioceseName, '" + dioceseName + "') gt -1)";
                }
                else {
                    odataUrl += "(indexof(DioceseName, '" + dioceseName + "') gt -1)";
                    filterSet = true;
                }
            }

            if (this.searchComponent.accountCode !== "-1") {
                if (filterSet) {
                    odataUrl += "and (GlobalRoleCode eq '" + this.searchComponent.accountCode + "')";
                }
                else {
                    odataUrl += "(GlobalRoleCode eq '" + this.searchComponent.accountCode + "')";
                    filterSet = true;
                }
            }
        }

        if (odataUrl) {
            odataUrl += "&";
        }

        return odataUrl;
    }

    private GetGlobalRoles(): void {
        this.accountsService
            .GetGlobalRoles()
            .subscribe(
            (response: GlobalRole[]) => {
                this.globalRoles = response;
                let allRoles = new GlobalRole();
                allRoles.code = "-1";
                allRoles.name = "ALL";
                this.globalRoles.unshift(allRoles);
                this.searchComponent.accountCode = allRoles.code;
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    private GetRoles(): void {
        this.accountsService
            .GetRoles()
            .subscribe(
            (response: AccountRole[]) => {
                this.roles = response;
                let allRoles = new AccountRole();
                allRoles.code = "-1";
                allRoles.name = "ALL";
                allRoles.description = "All roles";
                this.roles.unshift(allRoles);
                this.searchComponent.roleCode = allRoles.code;
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    private GetDioceses(): void {
        this.accountsService
            .GetDioceses()
            .subscribe(
            (response: Diocese[]) => {
                this.diocese = response;
                let diocese = new Diocese();
                diocese.publicId =  "00000000-0000-0000-0000-000000000001";
                diocese.dioceseId =  -1;
                diocese.dioceseName = "ALL";
                this.diocese.unshift(diocese);
                this.searchComponent.dioceseId = diocese.dioceseId.toString();

                let organisation = new Organisation();
                organisation.extOrganisationId = "00000000-0000-0000-0000-000000000001";
                organisation.publicId = "00000000-0000-0000-0000-000000000001"
                organisation.name = "ALL";
                this.organisations = [organisation]
            this.searchComponent.organisationId = organisation.extOrganisationId;

                if(this.currentUserService.IsGlobalAdmin() === true) {
             let organisationDelink = new Organisation();
             organisationDelink.extOrganisationId = "0778F56A-70FB-4A32-94D9-151828E21287";
             organisationDelink.name = "Not associated with an Organisation";
             organisationDelink.publicId = "0778F56A-70FB-4A32-94D9-151828E21287";
             this.organisations.splice(1,0, organisationDelink);
            } 
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    private GetOrganisations(): void {
        this.accountsService
            .GetOrganisations()
            .subscribe(
            (response: Organisation[]) => {
                this.organisations = response;
                let organisation = new Organisation();
                    organisation.extOrganisationId = "00000000-0000-0000-0000-000000000001";
                    organisation.publicId = "00000000-0000-0000-0000-000000000001"
                    organisation.name = "ALL";
                    this.organisations.splice(0,0,organisation);
                    this.searchComponent.organisationId = organisation.extOrganisationId;
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/accounts/accounts.component.ts